import api from '../collums-components/api/config';
import { v4 as uuidv4 } from 'uuid';
import { COLLUMS_DOMAIN } from '../services/storageKeys';

const DEVICE_ID_KEY = 'collums_device_id';

const readDeviceIdCookie = () => {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(/(?:^|;\s*)collums_device_id=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
};

const writeDeviceIdCookie = id => {
    if (typeof document === 'undefined') return;
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    const parts = [`${DEVICE_ID_KEY}=${encodeURIComponent(id)}`, `expires=${expires}`, 'path=/'];
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && COLLUMS_DOMAIN) {
        parts.push(`domain=${COLLUMS_DOMAIN}`);
    }
    document.cookie = parts.join('; ');
};

const getDeviceId = () => {
    let deviceId = readDeviceIdCookie();
    if (deviceId) return deviceId;
    deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (deviceId) {
        writeDeviceIdCookie(deviceId);
        return deviceId;
    }
    deviceId = uuidv4();
    writeDeviceIdCookie(deviceId);
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
    return deviceId;
};

const login = ({ email, password }) =>
    api.request({
        method: 'POST',
        url: '/login',
        data: { email: (email || '').toLowerCase(), password, deviceId: getDeviceId() }
    });

const getMe = () =>
    api.request({
        method: 'GET',
        url: '/user/me'
    });

const resetPassword = ({ email }) =>
    api.request({
        method: 'POST',
        url: '/reset-password',
        data: { email: (email || '').toLowerCase(), redirect: 'collums' }
    });

const changePassword = ({ password, code }) =>
    api.request({
        method: 'POST',
        url: `/reset-password/${code}`,
        data: { password }
    });
const forceLogout = () =>
    api.request({
        method: 'GET',
        url: `/user/logout?token=${localStorage.getItem('token') || ''}`
    });

const getJobs = () =>
    api.request({
        method: 'GET',
        url: '/jobs'
    });

const verify2FA = ({ twoFactorToken, code }) =>
    api.request({
        method: 'POST',
        url: '/auth/verify-2fa',
        data: { twoFactorToken, code }
    });

const resend2FA = ({ twoFactorToken }) =>
    api.request({
        method: 'POST',
        url: '/auth/resend-2fa',
        data: { twoFactorToken }
    });

const deleteSession = ({ email, password, sessionId }) =>
    api.request({
        method: 'POST',
        url: '/session/delete',
        data: { email: (email || '').toLowerCase(), password, sessionId }
    });

export default {
    login,
    getMe,
    resetPassword,
    changePassword,
    forceLogout,
    getJobs,
    verify2FA,
    resend2FA,
    deleteSession
};
